module.exports = __webpack_public_path__ + "img/5.4035eb33.png";